import tw, { styled } from 'twin.macro'

const Label = styled.label(() => [tw`block font-semibold text-gray-900 text-sm my-1.5 dark:(text-gray-300)`])

export default Label
